// FILE: /src/Components/Social Desings/YoutubeModal.js (FULLY UPDATED & IMPROVED)

import React, { useState, useMemo } from 'react';
import { Skeleton } from 'antd';
import UserName from '../../Comman Components/UserName';
import Images from '../../Comman Components/Images';
import moment from 'moment';

export default function YoutubeModal({ Previewimages: mediaItems = [], Previewcaptions = '', profile, title }) {
    const [open, setOpen] = useState(true);

    const videoItem = useMemo(() => mediaItems.find(item => item.type === 'video'), [mediaItems]);
    const videoUrl = videoItem?.permanentUrl || videoItem?.localUrl;

    const renderMedia = () => {
        if (!videoUrl) {
            return <Skeleton.Image style={{ width: '100%', height: 200, borderRadius: 0 }} active />;
        }
        return <video src={videoUrl} controls className="w-full h-auto max-h-72 object-contain bg-black" />;
    };

    return (
        <div className="w-full max-w-md mx-auto my-4 border border-gray-300 rounded-xl">
            <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-3 font-semibold text-left">
                <div className="flex items-center gap-2">
                    <i className="fa-brands fa-youtube text-red-600 text-lg"></i>
                    <span>YouTube</span>
                </div>
                <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
            </button>

            {open && (
                <div className="border-t border-gray-200">
                    {renderMedia()}
                    <div className="p-4 space-y-3">
                        {/* --- START OF FIX: Display channel-specific title prominently --- */}
                        <h3 className="font-bold text-lg text-gray-900 break-words">
                            {title || <span className="text-gray-400 italic">Your video title will appear here...</span>}
                        </h3>
                        {/* --- END OF FIX --- */}
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10">
                                {profile ? <Images Id={profile.platform_id} /> : <Skeleton.Avatar active size="large" shape="circle" />}
                            </div>
                            <div>
                                <div className="font-semibold text-sm">
                                    {profile ? <UserName Id={profile.platform_id} /> : <Skeleton.Input style={{ width: 150, height: 16 }} active size="small" />}
                                </div>
                                <div className="text-xs text-gray-500">
                                    <span>{moment().format("MMM D, YYYY")}</span>
                                </div>
                            </div>
                        </div>
                        {/* --- START OF FIX: Display main caption as the description in a box --- */}
                        <div className="bg-gray-100 p-3 rounded-lg mt-2">
                             <p className="text-sm text-gray-700 whitespace-pre-wrap">
                                {Previewcaptions || <span className="text-gray-400 italic">Your video description will appear here...</span>}
                            </p>
                        </div>
                        {/* --- END OF FIX --- */}
                    </div>
                </div>
            )}
        </div>
    );
}